import React, { useMemo } from 'react'
import { Text, VStack } from '@chakra-ui/react'

import SharedStack from '~components/shared/wrappers/shared-stack'
import {
    ClientFieldsFragment,
    PatientFieldsFragment,
    PatientInfo,
} from '~graphql/generated/graphql'
import PatientItem from './patient-item'
import { getAlivePatients } from '~utils/helpers'

interface Props {
    client: ClientFieldsFragment
    patientInfo: PatientInfo
    setPatient: (patient: PatientFieldsFragment) => void
}

export default function SuggestedPatients({
    client,
    patientInfo,
    setPatient,
}: Props) {
    const { first_name, patients } = client

    const filteredPatients = useMemo(
        () => getAlivePatients(patients),
        [patients],
    )

    return (
        <SharedStack w="full">
            {filteredPatients && filteredPatients.length > 0 ? (
                <>
                    <Text fontWeight="medium" fontSize="sm">
                        {first_name}'s patients
                    </Text>
                    <VStack spacing={4} w="full">
                        {filteredPatients?.map(p => (
                            <PatientItem
                                key={p.id}
                                patient={p}
                                patientInfo={patientInfo}
                                setPatient={setPatient}
                            />
                        ))}
                    </VStack>
                </>
            ) : (
                <Text fontWeight="semibold" alignSelf="center">
                    No patients found
                </Text>
            )}
        </SharedStack>
    )
}
